module.exports = __webpack_public_path__ + "dist/media/touch.c66da1fd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/icons/touch.svg
// module id = 377
// module chunks = 0